import { api, API_HOST } from '.'

export const downloadFileFromApi = async (url, fallbackFilename) => {
  let finalUrl = url
  if (url.includes('http://') || url.includes('https://')) {
    finalUrl = url
  } else {
    finalUrl = (process.env.NODE_ENV === 'development' ? API_HOST : window.location.origin) + url
  }
  return api.get(finalUrl, { responseType: 'blob' }).then((res) => {
    const filename =
      res.headers?.['content-disposition']?.match(/filename=['"]?([^'"\s]+)['"]?/)?.[1] ||
      fallbackFilename
    const url = window.URL.createObjectURL(new Blob([res.data], { type: res.headers.content_type }))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', filename)

    // Append to html link element page
    document.body.appendChild(link)

    // Start download
    link.click()

    // Clean up and remove the link
    link.parentNode.removeChild(link)

    return res
  })
}

export const dataURLtoBlob = (dataurl: string) => {
  const arr = dataurl.split(',')
  const mime = arr[0].match(/:(.*?);/)?.[1]
  const bstr = atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new Blob([u8arr], { type: mime })
}
